document.addEventListener('DOMContentLoaded', () => {

    let imagesSliders = document.querySelectorAll('.images-sliders');
    if(imagesSliders){
        imagesSliders.forEach((item)=>{
            new Swiper('.images-sliders', {
                rewind: true,
                effect: "fade",
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-img-next",
                    prevEl: ".sw-but-img-prev",
                },
            });
        });
    }

    let swiperTop = document.querySelectorAll('.swiper-top');
    if(swiperTop){
        const progressLine = document.querySelector(".progress");
        swiperTop.forEach((item)=>{
            new Swiper('.swiper-top', {
                loop: true,
                effect: "fade",
                fadeEffect: {
                    "crossFade": true
                },
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                },
                on: {
                autoplayTimeLeft(s, time, progress) {
                    progressLine.style.setProperty("width", Math.abs(progress-1)*100+'%');
                }
            }
            });
        });
    }

    let sliderSlide = document.querySelectorAll('.slider-slide');
    if(sliderSlide){
        sliderSlide.forEach((item)=> {
            new Swiper('.slider-slide', {
                loop: true,
                effect: "fade",
                autoHeight: true,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                }
            });
        });
    }

    let gallerySlider = document.querySelectorAll('.gallery-slider');
    if(gallerySlider){
        gallerySlider.forEach((item)=> {
            new Swiper('.gallery-slider', {
                watchSlidesProgress: true,
                loop: true,
                effect: "fade",
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-gal-next",
                    prevEl: ".sw-gal-prev",
                },
            });
        });
    }

    let locationTap = document.querySelectorAll('.location-block');
    let locationSlide = document.querySelectorAll('.location-slider');
    if(locationSlide){
        const locationSlider = new Swiper('.location-slider', {
            /*Optional parameters*/
            loop: true,
            effect: "fade",
            fadeEffect: {
                "crossFade": true
            }
        });
        locationTap.forEach(function(hB,hBc) {
            let hNav = hB.querySelectorAll('.location-point');
            let textG = hB.querySelector('.copy-generic');
            let textS = hB.querySelector('.location-slider');
            hNav.forEach(function(h_nav) {
                let navCount = h_nav.dataset.nav;
                h_nav.addEventListener('click', function(e){
                    e.preventDefault();
                    if(locationTap.length > 1){
                        locationSlider[hBc].slideTo(navCount, 1000);
                    } else {
                        locationSlider.slideTo(navCount, 1000);
                    }
                    hNav.forEach(function(h_nav) {
                        h_nav.classList.remove('active');
                    });
                    this.classList.add('active');
                    if(!textG.classList.contains('close')){
                        textG.classList.add('close');
                        textS.classList.add('open');
                    }
                });
                if(locationTap.length > 1){
                    locationSlider[hBc].on('slideChange', function () {
                        hNav.forEach(function(h_nav) {
                            let navC = h_nav.dataset.nav;
                            h_nav.classList.remove('active');
                            if(locationSlider[hBc].realIndex == navC){
                                h_nav.classList.add('active');
                            }
                        });
                    });
                } else {
                    let navIn = 0;
                    locationSlider.on('slideChange', function () {
                        hNav.forEach(function(h_nav) {
                            let navC = h_nav.dataset.nav;
                            h_nav.classList.remove('active');
                            if(locationSlider.realIndex == navC && navIn != 0){
                                h_nav.classList.add('active');
                            }
                            navIn++;
                        });
                    });
                }
            });
        });
    }

    let sliderSlideDot = document.querySelectorAll('.slider-slide-dot');
    if(sliderSlideDot){
        sliderSlideDot.forEach((item)=> {
            new Swiper('.slider-slide-dot', {
                loop: true,
                effect: "fade",
                uniqueNavElements:false,
                autoHeight: true,
                fadeEffect: {
                    "crossFade": true
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                },
            });
        });
    }

    let columnsSlider = document.querySelectorAll('.columns-slider');
    if(columnsSlider){
        columnsSlider.forEach((item)=> {
            new Swiper('.columns-slider', {
                watchSlidesProgress: true,
                slidesPerView: 1,
                spaceBetween: 0,
                autoHeight: true,
                loop: true,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                },
                breakpoints: {
                    780: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                    },
                    600: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                },
            });
        });
    }

});